var render = function render(){var _vm=this,_c=_vm._self._c;return _c('entity-select-view',_vm._b({staticClass:"employee-select-view",attrs:{"url":"/employees/search/","value":_vm.value,"map":_vm.contactMap,"labelMap":_vm.contactLabel,"validator":_vm.contactValidator,"clearMap":_vm.clearContact},on:{"input":function($event){return _vm.$emit('input', $event)}}},'entity-select-view',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }